import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { OwnerList } from '../interactions/OwnerList.jsx'

/**
 * CommitmentsCard — session-commitments (catalog #8, non-core).
 *
 * Owner-tagged list (R/M) with optional due-date. Absorbs today's
 * session-followups rows via migration shim.
 */

export function CommitmentsCard({ text = '', onChange, disabled = false }) {
  // Serialise items as JSON inside the note text for Phase F simplicity.
  let items = []
  try {
    if (text) items = JSON.parse(text)
  } catch {
    items = []
  }

  function handleChange({ items: next }) {
    onChange?.(JSON.stringify(next))
  }

  return (
    <CardFrame
      kind="session"
      icon="✓"
      iconClass="moss"
      title="Commitments"
      prompt="Who committed to what?"
      state={disabled ? 'locked' : items.length > 0 ? 'filled' : 'empty'}
      data-testid="session-card-commitments"
      className="session-card"
    >
      <OwnerList
        items={items}
        onChange={handleChange}
        maxItems={20}
        readOnly={disabled}
      />
    </CardFrame>
  )
}
